import React from "react";

import Timeline from "../elements/Timeline";

function Experience() {
  return (
    <section className="section" id="work">
      <div className="container">
        <div className="content_title has-text-white">Experience</div>
        <Timeline />
      </div>
    </section>
  );
}

export default Experience;
